import styled, { css } from 'styled-components';

import PremiumGuardLabel from '@web/premiumGuard/PremiumGuardLabel';

export const InnerContainer = styled.div`
  background: ${({ theme }): string => theme.colors.bodyBg};
  border-radius: 4px;
  box-shadow: 0px 10px 40px ${({ theme }): string => theme.colors.boxShadowDarker};
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 880px;
  z-index: 1;
`;

export const Header = styled.header`
  grid-column: 1 / span 2;
  margin: 40px 0 10px 0;
  text-align: center;
`;

const ContentContainerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 45px 75px 40px 75px;
`;

export const Main = styled.main`
  background: ${({ theme }): string => theme.colors.white};
  box-shadow: 0px 2px 8px 0px ${({ theme }): string => theme.colors.boxShadow};
  border: 1px solid ${({ theme }): string => theme.colors.separatorOnWhite};
  position: relative;
  ${ContentContainerStyle};
`;

export const Sidebar = styled.aside`
  ${ContentContainerStyle};
`;

export const RecommendedBadge = styled(PremiumGuardLabel)`
  left: 75px;
  margin-bottom: 5px;
  position: absolute;
  top: 15px;
  width: max-content;
`;

export const SubscriptionFooter = styled.footer`
  align-items: center;
  display: flex;
  gap: 10px;
`;
